import Logo from "../assets/img/logo.png";
import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa"; 
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from 'universal-cookie';

const Signup = () => {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [age, setAge] = useState("");
    const [jobStatus, setJobStatus] = useState("");
    const [education, setEducation] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    let navigate = useNavigate();

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const signup=async()=>{
        const dataFile = await axios.post("https://assistant.bordarna.ir/signup", {
            first_name: firstName,
            last_name: lastName,
            email: email,
            password: password,
            job: jobStatus,
            age: age,
            education: education
        });
        if (dataFile?.status == 200 || dataFile?.status == 204 || dataFile?.status == 201) {
            // const pieces = dataFile?.data?.split('/')
            // props.setFiles(true)
            console.log(123)
            console.log(dataFile.data)
              const cookies = new Cookies();
                    cookies.set('token', dataFile.data.access_token, { path: '/' });
                    cookies.set('name', email, { path: '/' });

            navigate('/selectType')
            // setSnipper(false)
        }
        else {
            console.log(dataFile)
            // setSnipper(false)
    
            alert("نام کاربری یا رمز عبور نادرست می باشد");
        }
    }
    return (
        <div className="h-screen flex flex-col justify-center items-center bg-gray-100 hasBackgroud">
            <div className="hidden lg:block w-[70%] lg:w-[95%] max-w-[600px] text-left mb-4">
            <a
                    href="/login"
                    className=" text-[#f4752a] text-[14px] border-b border-dashed pb-1 font-IRANYekanMedium hover:text-[#000]"
                >
                    حساب کاربری دارید؟ وارد شوید
                </a>
            </div>

            <div className="bg-white w-[70%] lg:w-[95%] max-w-[600px] rounded-xl p-6 shadow-lg flex flex-col items-center relative">
             
                <a
                    href="/"
                    className="block lg:hidden absolute top-4 left-4 text-[#f4752a] text-[14px] border-b border-dashed  font-IRANYekanMedium hover:text-[#000]"
                >
                    حساب کاربری دارید؟ وارد شوید
                </a>

                <img src={Logo} className="w-[80px] mb-4" alt="logo" />
                <h2 className="text-[15px] font-IRANYekanExtra mb-2">به دستیار هوشمند بانک سپه خوش آمدید!</h2>
                <h2 className="text-[18px] font-IRANYekanExtra text-[#f4752a]">ثبت نام در سامانه</h2>

            
                <div className="grid grid-cols-2 lg:grid-cols-1 gap-4 w-full mt-4">
         
                    <div>
                   
                        <p className="text-gray-600 mb-2 font-IRANYekanMedium text-right text-[15px]">نام</p>
                        <input
                            className="border p-2 rounded-lg w-full text-right font-IRANYekanMedium font-[10px] inputF border-[#c7c7c7]"
                            type="text"
                            placeholder="نام خود را وارد کنید"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                        />

                    
                        <p className="text-gray-600 mt-4 mb-2 font-IRANYekanMedium text-right">نام خانوادگی</p>
                        <input
                            className="border p-2 rounded-lg w-full text-right font-IRANYekanMedium inputF border-[#c7c7c7]"
                            type="text"
                            placeholder="نام خانوادگی خود را وارد کنید"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                        />

                       
                        <p className="text-gray-600 mt-4 mb-2 font-IRANYekanMedium text-right">ایمیل</p>
                        <input
                            className="border p-2 rounded-lg w-full text-right font-IRANYekanMedium inputF border-[#c7c7c7]"
                            type="email"
                            placeholder="ایمیل خود را وارد کنید"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>

               
                    <div>
                       
                        <p className="text-gray-600 mb-2 font-IRANYekanMedium text-right">سن</p>
                        <input
                            className="border p-2 rounded-lg w-full text-right font-IRANYekanMedium inputF border-[#c7c7c7]"
                            type="number"
                            placeholder="سن خود را وارد کنید"
                            value={age}
                            onChange={(e) => setAge(e.target.value)}
                        />

                   
                        <p className="text-gray-600 mt-4 mb-2 font-IRANYekanMedium text-right">وضعیت شغلی</p>
                        <select
                            className="border p-2 rounded-lg w-full text-right font-IRANYekanMedium inputF border-[#c7c7c7]"
                            value={jobStatus}
                            onChange={(e) => setJobStatus(e.target.value)}
                        >
                            <option value="">انتخاب کنید</option>
                            <option value="j1">بازرگان</option>
                            <option value="j2">شاغل</option>
                            <option value="j3">کارآفرین</option>
                            <option value="j4">بازنشسته</option>
                            <option value="j5">بیکار</option>
                            <option value="j6">دانش آموز</option>
                        </select>

                      
                        <p className="text-gray-600 mt-4 mb-2 font-IRANYekanMedium text-right">تحصیلات</p>
                        <select
                            className="border p-2 rounded-lg w-full text-right font-IRANYekanMedium inputF border-[#c7c7c7]"
                            value={education}
                            onChange={(e) => setEducation(e.target.value)}
                        >
                            <option value="">انتخاب کنید</option>
                            <option value="diploma">دیپلم</option>
                            <option value="bachelor">کارشناسی</option>
                            <option value="master">کارشناسی ارشد</option>
                            <option value="phd">دکترا</option>
                        </select>
                    </div>
                </div>

                
                <p className="text-gray-600 mt-4 mb-2 font-IRANYekanMedium text-right w-full">رمز عبور</p>
                <div className="relative w-full">
                    <input
                        className="border p-2 rounded-lg w-full text-right font-IRANYekanMedium inputF border-[#c7c7c7]"
                        type={showPassword ? "text" : "password"}
                        placeholder="رمز عبور خود را وارد کنید"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <button
                        className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500"
                        onClick={togglePasswordVisibility}
                    >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                </div>

               
                <button onClick={()=>signup()}
                    className="bg-[#f4752a] w-full font-IRANYekanExtra text-white px-4 py-2 rounded-lg mt-4 hover:bg-[#000]"
                >
                    ثبت نام
                </button>
            </div>
        </div>
    );
};

export default Signup;